
/**
 * State for deeplink price mismatch
 *
 * @export
 * @class State
 */
export class State {
	priceMismatch: {
        isPriceMismatch: boolean;
        originalFlightPrice: number;
        newFlightPrice: number;
    };
}

export const initialState: State = {
    priceMismatch: {
        isPriceMismatch: false,
        originalFlightPrice: 0,
        newFlightPrice: 0
    }
};
